import { useLocation } from 'react-router-dom';
import qs from 'qs';

/**
 * Whether the page is running inside the marketing site's iframe.
 *
 * Shared rather than re-parsed per component: the frame changes real
 * behaviour — chrome is hidden, height is posted to the parent, and the order
 * summary cannot be sticky, because sticky positioning inside an iframe
 * resolves against the frame's own viewport rather than the parent page's.
 */
export const useIsFramed = (): boolean => {
  const { search } = useLocation();
  const { from } = qs.parse(search, { ignoreQueryPrefix: true });
  return from === 'frame';
};
